import initState from '@shared/init-state-v0.1.0'
import type { JsNodeDef } from '@shared/node-v1.0.0'
import type { BaseJsProps } from '@shared/node-v1.0.0'
import { getPortDef } from '@shared/port-v1.0.0'
import { initStore } from '../component'

export type Props = BaseJsProps & { path?: string; store: Store }

export type Store = {
	page?: string
	unsub?: () => void
}

export default {
	hashTag: '#experimental',
	module: { dynamic: import('../component') },
	inNode: {
		inputs: [
			getPortDef({
				name: 'path',
				displayName: 'Page',
				group: 'Params',
				type: [],
				transform: (p, portDef) => {
					const navScheme = R.navigation?.scheme
					portDef.type = navScheme?.map((i) => ({ value: i.path, label: i.page })) || []
				},
			}),
		],
		outputs: [
			getPortDef({ name: 'params', displayName: 'Params', group: 'Data', type: 'object' }),
			getPortDef({ name: 'active', displayName: 'Active', group: 'States', type: 'boolean' }),
			getPortDef({ name: 'changed', displayName: 'Page changed', group: 'Signals', type: 'signal' }),
		],
	},
	afterNode: {
		triggerOnInputs: () => ['path'],
		transformPorts: async (p: Props, portDefs) => {
			await initState('navigation')

			// Хак, почему то теряются динамические порты
			// await new Promise((r) => setTimeout(r, 2000))

			const navScheme = R.navigation?.scheme
			const pageScheme = navScheme?.find((i) => i.path === p.path)

			if (pageScheme) {
				portDefs.outputs = portDefs.outputs.filter((i) => i.group !== 'Params') || []

				for (const param of pageScheme.params || []) {
					if (!portDefs.outputs?.some((i) => i.name === param)) {
						portDefs.outputs?.push(
							getPortDef({
								name: param,
								displayName: param,
								group: 'Params',
								type: 'string',
							})
						)
					}
				}
			}
		},
	},
	beforeComponent: {
		initialize: async (p: Props, noodlNode) => {
			await initState('navigation')

			p.store = initStore(p)

			// Отпишемся, когда родитель отмонтировался.
			if (noodlNode.nodeScope.componentOwner._forEachNode?.innerReactComponentRef) {
				noodlNode.nodeScope.componentOwner._forEachNode.innerReactComponentRef.componentWillUnmount = () => p.store.unsub?.()
			}

			// Отпишемся, когда удален.
			noodlNode._onNodeDeleted = () => p.store.unsub?.()
		},
	},
	disableCustomProps: true,
} satisfies JsNodeDef
